import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { createPortal } from "react-dom";

export default function LoginPromptModal({ onClose, onLoginSuccess, title, location ,tag,marks}) {
  const router = useRouter();

  // Prevent scrolling when the modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden"; // Disable scrolling
    return () => {
      document.body.style.overflow = ""; // Re-enable scrolling when modal is closed
    };
  }, []);

  const handleLogin = () => {
    // Simulate login success
    onLoginSuccess();
    onClose();
  };

  const handleNavigate = (path) => {
    const url = new URL(path, window.location.origin);

    // Always include the "tag" parameter
    url.searchParams.set("tag", tag);
    url.searchParams.set("marks", marks);

    // Add other parameters only if they exist
    if (title) url.searchParams.set("title", title);
    if (location) url.searchParams.set("location", location);

    window.location.href = url.toString();
  };

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-2xl max-w-md w-full mx-4 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors duration-200"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Modal Content */}
        <div className="text-center mt-2">
          <h2 className="text-2xl font-bold text-gray-800 mb-3">Login Required</h2>
          <p className="text-gray-600 mb-6">
            You need to be logged in to perform this action. Please log in or sign up to continue.
          </p>

          {/* Login and Signup Buttons */}
          <div className="flex justify-center gap-4">
            <button
             onClick={() => handleNavigate("https://portal.neetsupport.com/login")}
              className="bg-[#FF914D] text-white font-semibold px-6 py-2 rounded-lg shadow-lg hover:bg-[#ff7b1e] transform hover:scale-105 transition duration-200"
            >
              Log In
            </button>
            <button
              onClick={() => handleNavigate("https://portal.neetsupport.com/signup")}
              className="bg-[#FF914D] text-white font-semibold px-6 py-2 rounded-lg shadow-lg hover:bg-[#ff7b1e] transform hover:scale-105 transition duration-200"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>,
    typeof window !== "undefined" ? document.body : null
  );
}